import type { Mutation } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'
import {
  OtherProductItem,
  OtherProducts,
  TransactionDetails,
} from '@/api/send_detail/model/sendMailModel'
import { deepCopy } from '@/utils'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  //登録済み商品追加 modal
  [actionTypes.SET_PRODUCT_ADD_MODAL]: (state: State, status: boolean) => {
    state.showProductAddModal = status
  },

  //画面データ
  [actionTypes.SET_TRANSACTION_DETAILS]: (state: State, details: TransactionDetails) => {
    state.transactionDetails = { ...details }
  },

  //受領ステータス
  [actionTypes.SET_RECEIVE_STATUS]: (state: State, status: number) => {
    state.receiveStatus = status
  },

  [actionTypes.SET_PRODUCT_LIST]: (state: State, data: Array<any>) => {
    state.product_list = [...data]
  },
  [actionTypes.DELETE_PRDUCT_LIST]: (state: State, data: Array<any>) => {
    state.product_list = [...data]
  },

  //利用者別他社商品
  [actionTypes.SET_ORIGINAL_OTHER_PRODUCTS](state, list: OtherProducts): void {
    state.originalOtherProducts = deepCopy(list)
  },

  [actionTypes.SET_OTHER_PRODUCTS]: (state: State, item: OtherProducts) => {
    state.otherProducts = [...item]
  },

  [actionTypes.CLEAR_OTHER_PRODUCTS]: (state: State) => {
    state.otherProducts = []
  },

  [actionTypes.SET_OTHER_TOTAL_COUNT]: (state: State, status: number) => {
    state.total_count = status
  },

  [actionTypes.SET_OTHER_CURRENT_PAGE]: (state: State, status: number) => {
    state.current_page = status
  },

  [actionTypes.SET_OTHER_PAGE_SIZE]: (state: State, status: number) => {
    state.page_size = status
  },

  [actionTypes.SET_OHTER_ADD_SUBMIT_MODAL]: (state: State, status: boolean) => {
    state.showOtherAddSubmitModal = status
  },

  [actionTypes.SET_SELECTED_OTHER_PRODUCT]: (state: State, data: OtherProductItem) => {
    state.selectedOtherProduct = { ...data }
  },
}

export default mutations
